module.exports = __webpack_public_path__ + "img/Hunter-tauren-m-1.975e8d17.gif";